import { createPortal } from 'react-dom';

/** Rendu hors de la hiérarchie scroll (layout sidebar) pour un vrai plein écran. */
export default function Portal({ children }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
